module.exports = __webpack_public_path__ + "static/media/icon-25.a74b8a98.svg";